/* istanbul ignore file */
import { useInfiniteQuery } from "@tanstack/react-query";

import { UserColumnValuesRequestDTO } from "../../../apiclients/bstinsights";
import { default as useAcquireToken } from "../../AuthToken/Hooks/useAcquireToken";
import { default as useBSTInsightsAPI } from "../../../apiclients/api/bstinsightsapi";
import { PAGE_SIZE } from "./utils/constants";

// Query Key (useful for invalidating query cache)
export const columnFilterQueryKey = "get-user-column-filter-values-query-key";

// Hook for infinite query to load Column filter values
export const useColumnFilterValues = (payload: UserColumnValuesRequestDTO) => {
  const { getTokenSilently } = useAcquireToken();
  const { getUsersColumnFilterValues } = useBSTInsightsAPI();
  return useInfiniteQuery({
    queryKey: [columnFilterQueryKey, payload],
    queryFn: async ({ pageParam }: { pageParam: number }) => {
      const accessToken = await getTokenSilently();
      if (!accessToken) {
        return [];
      }
      return (
        getUsersColumnFilterValues(accessToken, {
          ...payload,
          pageSize: PAGE_SIZE,
          pageNumber: pageParam,
        }) || []
      );
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length > 0 ? allPages.length + 1 : undefined;
    },
    select: (data) => data.pages.flatMap((page) => page),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
